module.exports = __webpack_public_path__ + "static/media/l.84cbd435.m4a";